import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Pocetna from './pages/Pocetna';
import Usluge from './pages/Usluge';
import ONama from './pages/ONama';
import Kontakt from './pages/Kontakt';
import './App.css';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Pocetna />} />
          <Route path="usluge" element={<Usluge />} />
          <Route path="o-nama" element={<ONama />} />
          <Route path="kontakt" element={<Kontakt />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;